import { View, StyleSheet } from "react-native";
import { AuthGuard } from "./auth/guards/RouteGuards";
import OnboardingView from "./auth/views/OnboardingView";
import Colors from "../Resources/Color";
import { useCoachStore } from "./contexts/CoachStoreContext";

export default function OnboardingPage() {
  const coach = useCoachStore();

  return (
    <AuthGuard>
      <View style={styles.container}>
        <OnboardingView coach={coach} />
      </View>
    </AuthGuard>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.backgroundColor,
    flex: 1,
    width: "100%",
    height: "100%",
  },
});
